#root {
  font-family: Inter, system-ui, sans-serif;
  width: 100%;
  height: 100vh;
  max-height: 100vh;
  overflow: hidden;
}

html,
body {
  height: 100%;
  max-height: 100vh;
  overflow: hidden;
}

.app-root {
  height: 100vh;
  max-height: 100vh;
  overflow: hidden;
}

#map-container {
  width: 100%;
  height: 100%;
}

.map-layout {
  min-height: 0;
  height: 100%;
}

.map-bottom-sheet {
  flex-shrink: 0;
  max-height: 40vh;
  background: var(--surface);
  border-top-left-radius: 1.5rem;
  border-top-right-radius: 1.5rem;
  box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.08);
}

.map-bottom-sheet-list {
  min-height: 0;
  overflow-y: auto;
}

.agenda-scroll {
  min-height: 0;
  overflow-y: auto;
}

.calendar-shell {
  min-height: 0;
  height: 100%;
}

.calendar-shell > * {
  height: 100%;
}
